<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-back-button data-test="backButton"></ion-back-button>
        </ion-buttons>
        <ion-title data-test="title" #title (click)="onTitleClick()">Reports</ion-title>
        <ion-buttons slot="end">
            <ion-button data-test="more" [disabled]=vb.disabled color="light" id="more" (click)="onMoreClick($event)">
                <ion-icon name="ellipsis-horizontal"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-list id="divToPrint">
        <div id="report">
            @for (page of vm.pages; track $index) {
            <div class="page">
                <div class="pageHeader">
                    <table>
                        <tr>
                            <td class="asOfDate">As of: {{vm.pageHeader.asOfDate}}</td>
                            <td class="pageNumber">Page: {{page.pageNumber}} of {{vm.pageHeader.numReportPages}}</td>
                        </tr>
                    </table>
                    <table>
                        <tr>
                            <td class="title">{{vm.pageHeader.reportTitle}}</td>
                        </tr>
                        <tr>
                            @if (vm.mmStartingDate) {
                            <td class="period">
                                Period: {{vm.pageHeader.startingDate}} thru {{vm.pageHeader.endingDate}}
                            </td>
                            }
                        </tr>
                    </table>
                </div>

                <!-- Column Headers Section -->
                <div class="columnHeader report-grid" [style.grid-template-columns]="vm.gridTemplateColumns">
                    @for (columnName of vm.pageHeader.headerColumns; track $index) {
                    <div class="grid-cell header-cell" (click)="onHeaderClick($index)">
                        {{columnName}}
                        @if (vm.isDebugMode && vm.selectedColumnIndex === $index) {
                        <div class="debug-width-overlay">
                            <div class="width-controls">
                                <button class="width-btn" (click)="adjustColumnWidth($index, -10); $event.stopPropagation()">-10</button>
                                <span class="width-display">{{getColumnWidth($index)}}px</span>
                                <button class="width-btn" (click)="adjustColumnWidth($index, 10); $event.stopPropagation()">+10</button>
                            </div>
                        </div>
                        }
                    </div>
                    }
                </div>

                @if (vm.isDebugMode && page.pageNumber === 1) {
                <div class="debug-toolbar">
                    <button class="debug-btn" (click)="copyWidthsToClipboard()">📋 Copy Column Widths</button>
                    <button class="debug-btn" (click)="resetColumnWidths()">↺ Reset Widths</button>
                    <div class="debug-info">Click column header to adjust width</div>
                </div>
                }

                <!-- Data Section -->
                <div class="dataSection report-grid" [style.grid-template-columns]="vm.gridTemplateColumns">
                    @for (row of page.dataRows; track $index) {
                        @for (cell of row.cells; track $index) {
                        <div class="grid-cell data-cell" [class.subtotalRow]="isSubtotalRow(row)">
                            {{cell.value}}
                        </div>
                        }
                    }
                </div>

                @if (page.summaryRows && page.summaryRows.length > 0) {
                <div class="summarySection report-grid" [style.grid-template-columns]="vm.gridTemplateColumns">
                    @for (row of page.summaryRows; track $index) {
                        @for (cell of row.cells; track $index) {
                        <div class="grid-cell summary-cell">
                            {{cell.value}}
                        </div>
                        }
                    }
                </div>
                }
            </div>
            }
        </div>
    </ion-list>
</ion-content>